import { useState, useMemo } from "react";

/**
 * Page-size selection on antd Tables across this app kept resetting to the
 * default because `pagination={{ pageSize: 10 }}` is a brand-new object
 * literal on every render, with nothing tracking the user's selection or an
 * onChange wired up to persist it — so any unrelated re-render (search,
 * column settings, etc.) snapped it back to 10. This hook tracks current
 * page + page size in state so selections actually stick.
 */
const useTablePagination = (defaultPageSize = 10, pageSizeOptions = ["10", "20", "50", "100"]) => {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const pagination = useMemo(
    () => ({
      current,
      pageSize,
      showSizeChanger: true,
      pageSizeOptions,
      showTotal: (total) => `Total ${total} items`,
      onChange: (page, size) => {
        setCurrent(page);
        if (size !== pageSize) {
          setPageSize(size);
        }
      },
      onShowSizeChange: (page, size) => {
        setCurrent(1);
        setPageSize(size);
      },
    }),
    [current, pageSize, pageSizeOptions]
  );

  return pagination;
};

export default useTablePagination;
